import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerTimeslot = (props: any) => {

  // Generic 6 years range if no min and max date (Doctor role, no event range).
  // Needed to move from month to month correctly.
  let minDate = ((props.minDate) ? new Date(props.minDate) : moment().add(-3, 'y').toDate());
  let maxDate = ((props.maxDate) ? new Date(props.maxDate) : moment().add(+3, 'y').toDate());
  let highlights = props.highlights || []
  const highlightWithRanges = [
    {
      "dayHaveTimeslot": highlights.map((highlight: string) => new Date(highlight)),
    }
  ];
  const onMonthChange = (day: Date) => {
    if (typeof props.setMonthShow === "function") {
      props.setMonthShow(day)
    }
  }

  let date = props.date ?? new Date();
  return (
    <>
      <div className="datePickerTimeslot">
        <DatePicker
          minDate={minDate}
          maxDate={maxDate}
          onMonthChange={onMonthChange}
          highlightDates={highlightWithRanges}
          selected={date} onChange={(date: Date) => props.handleChange(date)} inline />
      </div>
    </>
  )
}

export default DatePickerTimeslot
